// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import savingCollectionTypes from './saving-collection.types';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	getSearchMemberSavingDetailsFailure,
	getSearchMemberSavingDetailsResponseChanged,
	getSearchMemberSavingDetailsSuccess,
	getParticularAccountInfoSuccess,
	getParticularAccountInfoFailure,
	getParticularAccountInfoResponseChanged,
	addSavingMemberSavingDetailsResponseChanged,
	addSavingMemberSavingDetailsFailure,
	addSavingMemberSavingDetailsSuccess,
	deleteSavingMemberSavingDetailsFailure,
	deleteSavingMemberSavingDetailsSuccess,
	deleteSavingMemberSavingDetailsResponseChanged,
	fetchSearchMemberSavingDetailsSuccess,
	fetchSearchMemberSavingDetailsFailure,
	fetchSearchMemberSavingDetailsResponseChanged,
} from '../saving-collection/saving-collection.action';
import {
	getSearchMemberSavingDetailsAPI,
	addSavingMemberSavingDetailsAPI,
	deleteSavingMemberSavingDetailsAPI,
	fetchMemberSavingDetailsAPI,
	getParticularAccountInfoAPI,
} from './saving-collection.service';

/** *********************  GET SEARCH MEMBER SAVING DETAILS START ******************** */
export function* getSearchMemberSavingDetails({ payload }: any) {
	try {
		const key = 'FetchMemberSavingsDetailKey';
		const { databaseName, memberCompanyID, memberID, searchMemberValue, searchMemberType } =
			payload;
		const jsonData = {
			SearchMemberValue: searchMemberValue,
			SearchMemberType: searchMemberType,
			DatabaseName: databaseName,
			MemberCompanyID: memberCompanyID,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getSearchMemberSavingDetailsAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSearchMemberSavingDetailsFailure(responseData.data));
		} else {
			yield put(getSearchMemberSavingDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSearchMemberSavingDetailsFailure(error));
	}
}

export function* getSearchMemberSavingDetailsResponse() {
	yield put(getSearchMemberSavingDetailsResponseChanged());
}

export function* onGetSearchMemberSavingDetails() {
	yield takeLatest(
		savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_START,
		getSearchMemberSavingDetails,
	);
}

export function* onGetSearchMemberSavingDetailsResponseReset() {
	yield takeLatest(
		savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_RESPONSE_RESET,
		getSearchMemberSavingDetailsResponse,
	);
}

/** *********************  GET SEARCH MEMBER SAVING DETAILS END ******************** */

/** ********************* FETCH MEMBER SAVING DETAILS START ******************** */
export function* fetchSearchMemberSavingDetails({ payload }: any) {
	try {
		const key = 'GetMemberSavingsDetailKey';
		const { databaseName, memberCompanyID, memberID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			MemberCompanyID: memberCompanyID,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchMemberSavingDetailsAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchSearchMemberSavingDetailsFailure(responseData.data));
		} else {
			yield put(fetchSearchMemberSavingDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchSearchMemberSavingDetailsFailure(error));
	}
}

export function* fetchSearchMemberSavingDetailsResponse() {
	yield put(fetchSearchMemberSavingDetailsResponseChanged());
}

export function* onFetchSearchMemberSavingDetails() {
	yield takeLatest(
		savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_START,
		fetchSearchMemberSavingDetails,
	);
}

export function* onFetchSearchMemberSavingDetailsResponseReset() {
	yield takeLatest(
		savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_RESPONSE_RESET,
		fetchSearchMemberSavingDetailsResponse,
	);
}
/** ******************** FETCH MEMBER SAVING DETAILS END ******************** */

/** *********************  GET PARTICULAR ACCOUNT INFO START ******************** */

export function* getParticularAccountInfo({ payload }: any) {
	try {
		const key = 'GetParticularAccountNameInfoKey';
		const { databaseName, companyID, memberID, infogCompanyID, accountName } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			MemberID: memberID,
			InfogID: infogCompanyID,
			AccountName: accountName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getParticularAccountInfoAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularAccountInfoFailure(responseData.data));
		} else {
			yield put(getParticularAccountInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularAccountInfoFailure(error));
	}
}

export function* getParticularAccountInfoResponse() {
	yield put(getParticularAccountInfoResponseChanged());
}

export function* onGetParticularAccountInfo() {
	yield takeLatest(
		savingCollectionTypes.GET_PARTICULAR_ACCOUNT_INFO_START,
		getParticularAccountInfo,
	);
}

export function* onGetParticularAccountInfoResponseReset() {
	yield takeLatest(
		savingCollectionTypes.GET_PARTICULAR_ACCOUNT_INFO_RESPONSE_RESET,
		getParticularAccountInfoResponse,
	);
}
/** *********************  GET PARTICULAR ACCOUNT INFO END ******************** */

/** *********************  ADD SAVING MEMBER SAVING ACCOUNT START ******************** */
export function* addSavingMemberSavingDetails({ payload }: any) {
	try {
		const key = 'CreateMemberSavingKey';
		const {
			databaseName,
			companyID,
			memberID,
			branchID,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenomination,
			requestedRelationship,
			requestedBy,
			requestedPhoneNumber,
			totalSavingAmount,
			receiptNumber,
			repayDate,
			narration,
			savingStatus,
			userID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			MemberID: memberID,
			BranchID: branchID,
			FiveHundred: fiveHundred,
			TwoHundred: twoHundred,
			Hundred: hundred,
			Fifty: fifty,
			Twenty: twenty,
			Ten: ten,
			Five: five,
			Two: two,
			One: one,
			TotalDenominationAmount: totalDenomination,
			TransactionAmount: totalSavingAmount,
			RequestedDate: repayDate,
			VoucherNumber: receiptNumber,
			Description: narration,
			RequestedRelationship: requestedRelationship,
			RequestedPhoneNumber: requestedPhoneNumber,
			RequestedBy: requestedBy,
			CreatedBy: userID,
			SavingStatus: savingStatus,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addSavingMemberSavingDetailsAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addSavingMemberSavingDetailsFailure(responseData.data));
		} else {
			yield put(addSavingMemberSavingDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addSavingMemberSavingDetailsFailure(error));
	}
}
export function* addSavingMemberSavingDetailsResponse() {
	yield put(addSavingMemberSavingDetailsResponseChanged());
}
export function* onAddSavingMemberSavingDetails() {
	yield takeLatest(
		savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_START,
		addSavingMemberSavingDetails,
	);
}
export function* onAddSavingMemberSavingDetailsResponseReset() {
	yield takeLatest(
		savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_RESET,
		addSavingMemberSavingDetailsResponse,
	);
}
/** *********************  ADD SAVING MEMBER SAVING ACCOUNT END ******************** */

/** *********************  DELETE SAVING MEMBER SAVING ACCOUNT START ******************** */
export function* deleteSavingMemberSavingDetails({ payload }: any) {
	try {
		const key = 'DeleteMemberSavingEntryKey';
		const {
			databaseName,
			companyID,
			memberID,
			memberSavingID,
			userID,
			debitAccountID,
			creditAccountID,
			transactionType,
			infogID,
			createdFor,
			paidDate,
			savingsAmount,
			isEODApproved,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			MemberID: memberID,
			MemberSavingID: memberSavingID,
			DeletedBy: userID,
			DebitAccountID: debitAccountID,
			CreditAccountID: creditAccountID,
			TransactionType: transactionType,
			InfogID: infogID,
			CreatedBy: userID,
			CreatedFor: createdFor,
			PaidDate: paidDate,
			SavingsAmount: savingsAmount,
			IsEODApproved: isEODApproved,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteSavingMemberSavingDetailsAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteSavingMemberSavingDetailsFailure(responseData.data));
		} else {
			yield put(deleteSavingMemberSavingDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteSavingMemberSavingDetailsFailure(error));
	}
}
export function* deleteSavingMemberSavingDetailsResponse() {
	yield put(deleteSavingMemberSavingDetailsResponseChanged());
}
export function* onDeleteSavingMemberSavingDetails() {
	yield takeLatest(
		savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_START,
		deleteSavingMemberSavingDetails,
	);
}
export function* onDeleteSavingMemberSavingDetailsResponseReset() {
	yield takeLatest(
		savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_RESET,
		deleteSavingMemberSavingDetailsResponse,
	);
}
/** *********************  DELETE SAVING MEMBER SAVING ACCOUNT END ******************** */

export function* savingCollectionSaga() {
	yield all([
		call(onGetSearchMemberSavingDetails),
		call(onGetSearchMemberSavingDetailsResponseReset),
		call(onGetParticularAccountInfo),
		call(onGetParticularAccountInfoResponseReset),
		call(onAddSavingMemberSavingDetails),
		call(onAddSavingMemberSavingDetailsResponseReset),
		call(onDeleteSavingMemberSavingDetails),
		call(onDeleteSavingMemberSavingDetailsResponseReset),
		call(onFetchSearchMemberSavingDetails),
		call(onFetchSearchMemberSavingDetailsResponseReset),
	]);
}
